<template>
  <TempCodeProvisionHistoryJournal
    :client-id="$route.params.id"
    :include-doorphone-address="true"
  />
</template>

<script>
import TempCodeProvisionHistoryJournal from '@/components/doorphone/DetailDoorphone/components/TempCodeProvisionHistoryJournal.vue';

export default {
  name: 'ClientTempCodeProvisionHistoryTab',
  components: { TempCodeProvisionHistoryJournal },
};
</script>
